import { Permission, AccessTypes, PermissionBankItem } from './typed-permissions';

export class PermissionManager {

    public PermissionBank: PermissionBankItem[];
    public UserPermissions: object;
    public PermissionFile: object;

    constructor(permissionFile: object, permissionString: string = '{}') {

        var userPermissions = {};

        if (permissionString) {
            userPermissions = JSON.parse(permissionString);
        }

        this.PermissionFile = permissionFile;

        //var adminPermission = {
        //  AllPermissions: '*'
        //};

        // var employeePermission = {
        //   AllPermissions: {
        //     Requests: {
        //       Overtime: ['1'],
        //     }
        //   }
        // };

        //this.Permissions = {
        //  //'AppPermissions': {
        //  AllPermissions: {
        //    Employees: {
        //      List: ['1', '2', '3'],
        //    }
        //  }
        //  //}
        //};

        //userPermissions = employeePermission;

        this.UserPermissions = userPermissions;

        this.PermissionBank = new Array<PermissionBankItem>();

        this.permissionIterator1(this.PermissionFile, userPermissions, this.PermissionBank);

        //console.log(this.PermissionBank)
    }

    public permissionIterator1(permissionCursor, accessCursor, permissionBank: PermissionBankItem[]) {
        var accessTypes = new Array<AccessTypes>();
        var accessValue = null;

        //Full Access (Parent Checked)
        if (accessCursor === null) {
            accessTypes = [AccessTypes.Read, AccessTypes.Write, AccessTypes.Delete];
            accessValue = permissionCursor === null ? null : permissionCursor.FullAccess;
        }

        if (((typeof accessCursor === 'string') || (accessCursor instanceof String))) {
            if (accessCursor === '*') {
                //Full Access
                this.permissionIterator1(permissionCursor, null, permissionBank);
            }
            else {
                accessValue = accessCursor;
            }
        }

        if (Array.isArray(accessCursor)) {
            if (accessCursor.indexOf(AccessTypes.Read) > -1) {
                accessTypes.push(AccessTypes.Read);
            }

            if (accessCursor.indexOf(AccessTypes.Write) > -1)
                accessTypes.push(AccessTypes.Write);

            if (accessCursor.indexOf(AccessTypes.Delete) > -1)
                accessTypes.push(AccessTypes.Delete);
        }

        if (permissionCursor instanceof Object) {
            for (var key in permissionCursor) {

                if (accessCursor === null) {
                    this.permissionIterator1(permissionCursor[key], null, permissionBank)
                }
                else {
                    if (accessCursor[key]) {
                        this.permissionIterator1(permissionCursor[key], accessCursor[key], permissionBank);
                    }
                }

            }
        }

        if (permissionCursor instanceof Permission && (accessTypes.length > 0 || accessValue !== null)) {
            if (accessTypes.length === 0)
                accessTypes = null;

            permissionBank.push(new PermissionBankItem(permissionCursor, accessTypes, accessValue));
        }
    }

    public locatePermissionInBank(permissionToCheck: Permission): PermissionBankItem {
        var permissionMatch = this.PermissionBank.filter(x => { return x.Permission === permissionToCheck });

        if (permissionMatch.length > 0) {
            return permissionMatch[0];
        }

        return null;
    }

    private checkPermissionBank(permissionToCheck: Permission, accessTypeToCheck: AccessTypes): boolean {
        var access = false;

        var permissionMatch = this.locatePermissionInBank(permissionToCheck);

        if (permissionMatch !== null)
            access = permissionMatch.AccessTypes.indexOf(accessTypeToCheck) > -1;

        return access;
    }

    canRead(permission: Permission): boolean {
        return this.checkPermissionBank(permission, AccessTypes.Read);
    }

    canWrite(permission: Permission): boolean {
        return this.checkPermissionBank(permission, AccessTypes.Write);
    }

    canDelete(permission: Permission): boolean {
        return this.checkPermissionBank(permission, AccessTypes.Delete);
    }

    canAccess(permission: Permission): boolean {
        return this.checkPermissionBank(permission, AccessTypes.Read);
    }

    accessValue(permission: Permission): string {
        var access = permission.LeastAccess;

        var permissionMatch = this.locatePermissionInBank(permission);

        if (permissionMatch !== null && permissionMatch.AccessValue !== null)
            access = permissionMatch.AccessValue

        return access;
    }
};
